module.exports = __webpack_public_path__ + "static/img/quote_right.923d201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quote_right.png
// module id = e47A
// module chunks = 0